import { GambitType } from "./gambit-type";

export interface IGambitData {
    id: number,
    gambitType: GambitType,
    collectedData: string,
    insertedDate: Date,
    updatedDate: Date,
}